var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.80002C13.3256 4.80002 14.4001 3.7255 14.4001 2.40001C14.4001 1.07452 13.3256 0 12.0001 0C10.6746 0 9.6001 1.07452 9.6001 2.40001C9.6001 3.7255 10.6746 4.80002 12.0001 4.80002Z",
    fill: "#8A8A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.3996C13.3256 14.3996 14.4001 13.3251 14.4001 11.9996C14.4001 10.6741 13.3256 9.59961 12.0001 9.59961C10.6746 9.59961 9.6001 10.6741 9.6001 11.9996C9.6001 13.3251 10.6746 14.3996 12.0001 14.3996Z",
    fill: "#8A8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 23.9992C13.3256 23.9992 14.4001 22.9247 14.4001 21.5992C14.4001 20.2737 13.3256 19.1992 12.0001 19.1992C10.6746 19.1992 9.6001 20.2737 9.6001 21.5992C9.6001 22.9247 10.6746 23.9992 12.0001 23.9992Z",
    fill: "#8A8A8A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.66c3f117.svg";
export { ForwardRef as ReactComponent };